/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React from 'react';
import { observer } from 'mobx-react';
import { APP_SECTION_LAYOUTS } from '../../layouts/layoutConstants';

export default observer(({
    appConfig, appsSkeletonModel, allAppsModel, layouts,
    routingProps, appSection, subSection, sectionHeader,
}) => {
    let sectionLayoutId = APP_SECTION_LAYOUTS.CARD_VIEW;
    if (appSection && appSection.layoutId && layouts.appSection[appSection.layoutId]) {
        sectionLayoutId = appSection.layoutId;
    }

    if (subSection && subSection.layoutId && layouts.appSection[subSection.layoutId]) {
        sectionLayoutId = subSection.layoutId;
    }

    if (sectionHeader && sectionHeader.layoutId && layouts.appSection[sectionHeader.layoutId]) {
        sectionLayoutId = sectionHeader.layoutId;
    }

    const AppsSectionLayout = layouts.appSection[sectionLayoutId];

    return (
        <AppsSectionLayout
            appConfig={appConfig}
            appsSkeletonModel={appsSkeletonModel}
            allAppsModel={allAppsModel}
            routingProps={routingProps}
            appSection={appSection}
            subSection={subSection}
            sectionHeader={sectionHeader}
            layoutId={sectionLayoutId}
        />
    );
});
